import React from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ConstructionBanner } from '@/components/ConstructionBanner';
import { Home } from '@/pages/Home';

export const App: React.FC = () => {
  return (
    <>
      <Header />
      <ConstructionBanner />
      <Home />
      <Footer />
    </>
  );
};
